var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { kebabCase } from "lodash";
export var useContentSlice = function (input) {
  var title = input.title || JSON.stringify(input);
  var defaultSlug = kebabCase(title).substring(0, 70);
  var _a = input.slug,
    slug = _a === void 0 ? defaultSlug : _a,
    _b = input.id,
    id = _b === void 0 ? defaultSlug : _b,
    content = input.content;
  return __assign(__assign({}, input), {
    id: id,
    slug: slug,
    content: content
  });
};